// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { createAction } from '@reduxjs/toolkit';

export const SetFoldersAction = createAction<IFolder[]>('folderList/SetFoldersAction');

export const CreateFolderSuccessAction = createAction<IFolder>('folderList/CreateFolderSuccessAction');

export const DeleteFolderSuccessAction = createAction<string>('folderList/DeleteFolderAction');

export const GetFoldersSuccessAction = createAction<IFolder[]>('folderList/GetFoldersSuccess');

export const UpdateFolderSuccessAction = createAction<IFolder>('folderList/UpdateFolderSuccessAction');

export const SetProjectsInFolderAction = createAction<IProject[]>('folderList/SetProjectsInFolderAction');

export const UpdateProjectThumbnailAction = createAction<{ projectId: string, thumbnail: string }>('folderList/UpdateProjectThumbnailAction');

export const SetSelectedFolderAction = createAction<IFolder>('folderList/SetSelectedFolderAction');

export const ClearSelectedFolderAction = createAction('folderList/ClearSelectedFolderAction');
